import React, { useEffect, useState } from "react";
import "../../Style.css";
import "../../Brand.css";
import "../../Responsive.css";
import {
  Button,
  Container,
  Grid,
  Box,
  Stack,
  Typography,
  Avatar,
  Link,
  Tab,
  Card,
  Checkbox,
  IconButton,
  TextField,
  FormControl,
  Autocomplete,
} from "@mui/material";
import PropTypes from "prop-types";
import Infopoint_Logo from "../../images/Infopoint.png";
import up_arrow from "../../images/up-arrow.png";
import EventIcon from "@mui/icons-material/Event";
import PlaceIcon from "@mui/icons-material/Place";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useParams, useSearchParams } from "react-router-dom";

// Modal
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import VerifiedIcon from "@mui/icons-material/Verified";
import ServiceItem from "./ServiceItem";
import { connectToStore } from "../../data/store";
import UserHelper from "../../core/UserHelper";
import { PostAsyncAnonymous } from "../../core/serviceClient";
import Utils from "../../core/Utils";
import { equals } from "validator";
import moment from "moment";
import PublicReservationHelper from "../../core/PublicReservationHelper";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Loader from "../common/Loader";
import { SuccessDialog } from "../common/SuccessDialog";
import MessagePopup from "../common/MessagePopUp";
import { India, CustomerBookingActions, VehicleTypes } from "../../core/Constants";
import NumericTextField from "../common/controls/NumericTextField";
import CountryHelper from "../../core/CountryHelper";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Stack spacing={2}>{children}</Stack>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BrandHome = () => {
  const { BrandPath } = useParams();
  const [searchParams] = useSearchParams(); // Get query parameters

  useEffect(() => {
    //getEncryptedData();
    const encryptedData = searchParams.get("data");
    if (encryptedData) {
      const correctedData = decodeURIComponent(encryptedData);
      getDecryptedData(correctedData);
    }
  }, [searchParams, BrandPath]);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 7000);

    return () => clearTimeout(timer);
  }, []);
  var body = document.body;
  body.classList.add("brandHome");

  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const [localSettings, setLocalSettings] = useState({});
  const [serviceValue, setServiceValue] = useState(0);
  const [timeValue, setTimeValue] = useState(0);
  const [checked, setChecked] = useState(true);
  const [showServies, setShowServies] = useState(true);
  const [showTime, setShowTime] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [serviceList, setServiceList] = useState([]);
  const [serviceCategory, setServiceCategory] = useState([]);
  const [categorizedServices, setCategorizedServices] = useState({});
  const [selectedServices, setSelectedServices] = useState([]);
  const [branchDetails, setBranchDetails] = useState(null);
  const [branchLogoURL, setBranchLogoURL] = useState(null);
  const [showOTP, setShowOTP] = useState(false);
  const [showMobileNo, setShowMobileNo] = useState(false);
  const [isConfirmBooking, setIsConfirmBooking] = useState(false);

  const [reservations, setReservations] = useState([]);
  const [openReservationDetails, setOpenReservationDetails] = useState([]);
  const [closedReservationDetails, setClosedReservationDetails] = useState([]);
  const [reservationDetails, setReservationDetails] = useState({});
  const [serviceStartTime, setServiceStartTime] = useState("");
  const [serviceEndTime, setServiceEndTime] = useState("");

  const [selectedDate, setSelectedDate] = useState([
    moment(),
    moment().add(7, "days").endOf("day"),
  ]);
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedTimestring, setSelectedTimeString] = useState("");
  const [selectedDaystring, setSelectedDaystring] = useState("");
  const [selectedMonthString, setSelectedMonthString] = useState("");
  const [businessId, setBusinessId] = useState("");
  const [branchId, setBranchId] = useState("");
  const [customerMobileNumber, setCustomerMobileNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [otpId, setOTPId] = useState("");
  const [otp, setOTP] = useState("");
  const [customerBookingAction, setCustomerBookingAction] = useState("");
  const [socialMediaSource, setSocialMediaSource] = useState("");
  const [reservationBranchImageUrl, setReservationBranchImageUrl] = useState("");
  const [makeList, setMakeList] = useState([]);
  const [makeModelList, setMakeModelList] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [customerVehicleMake, setCustomerVehicleMake] = useState("");
  const [customerVehicleModel, setCustomerVehicleModel] = useState("");
  const [customerVehicleColor, setCustomerVehicleColor] = useState("");
  const [isAutomobileBusiness, setIsAutomobileBusiness] = useState(false);
  const [customerVehicleNo, setCustomerVehicleNo] = useState("");
  const [isAddVehicleDetails, setIsAddVehicleDetails] = useState(false);

  const totalAmount = selectedServices?.reduce((sum, serviceId) => {
    const service = serviceList.find((x) => x.id === serviceId);
    return sum + (service?.price || 0);
  }, 0);

  const totalTime = selectedServices?.reduce((sum, serviceId) => {
    const service = serviceList.find((x) => x.id === serviceId);
    return sum + (service.serviceTime + service.postServiceTime);
  }, 0);

  const handleServiceTabsChange = (event, newValue) => {
    setServiceValue(newValue);
  };

  const closeSuccess = () => {
    setShowSuccess(false);
  };
  const closeAlert = () => {
    setShowAlert(false);
    if (customerBookingAction === CustomerBookingActions.WrongOTP) {
      setShowOTP(true);
    }
  };

  const handleTimeTabsChange = (event, newValue) => {
    setTimeValue(newValue);
  };

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleToggle = (serviceId) => {
    setSelectedServices(
      (prevSelected) =>
        prevSelected.includes(serviceId)
          ? prevSelected.filter((id) => id !== serviceId) // uncheck
          : [...prevSelected, serviceId] // check
    );
  };

  const handleShowTime = (event) => {
    if (Utils.IsNullOrEmptyArray(selectedServices)) {
      setAlertMessage("Please select service");
      setShowAlert(true);
      return;
    }
    setShowServies(false);
    setShowTime(true);
  };

  const handleShowServices = (event) => {
    setShowServies(true);
    setShowTime(false);
  };

  const handleClickOpenModal = () => {
    if (
      !Utils.IsNullOrEmpty(selectedTimestring) &&
      !Utils.IsNullOrEmpty(selectedDaystring)
    ) {
      setOpenModal(true);
      setShowMobileNo(true);
    } else {
      setAlertMessage("Please select time");
      setShowAlert(true);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setShowOTP(false);
    setIsConfirmBooking(false);
  };

  const GetAllServices = async (BusinessId) => {
    var requestBody = {
      BusinessId: BusinessId,
      QueryParameters: [BusinessId],
      QueryId: "GetAllProductsByBusiness",
    };
    var packageRequestBody = {
      BusinessId: BusinessId,
      QueryParameters: [BusinessId],
      QueryId: "GetAllPackageProductsByBusiness",
    }
    let result = await PostAsyncAnonymous("Branch/GetProduct", requestBody);
    let result2 = await PostAsyncAnonymous(
      "Branch/GetPackage", packageRequestBody
    );
    var Service = result.data.filter(
      (item) => item.isMaterial == false && item.service == true
    );
    Service = Service.map((service) => ({
      ...service,
      onOrderQuantity: service?.onOrderQuantity ? service.onOrderQuantity : 1,
    }));
    var PackageList = "";
    if (!Utils.IsNullOrEmptyArray(result2.data)) {
      PackageList = result2.data
      PackageList = PackageList.map((packageitem) => ({
        ...packageitem,
        onOrderQuantity: packageitem?.onOrderQuantity ? packageitem.onOrderQuantity : 1,
      }))
    }
    if (!Utils.IsNullOrEmptyArray(PackageList)) {
      Service = [...Service, ...PackageList];
    }
    if (!Utils.IsNullOrEmptyArray(Service)) {
      const listofServices = Service;
      setServiceList(listofServices);
      const distinctServiceCategories = [
        ...new Set(
          listofServices.map((Service) => Service.class).filter(Boolean)
        ),
      ];
      distinctServiceCategories.unshift("All Services");
      setServiceCategory(distinctServiceCategories);

      // Group services by their 'Class' property
      const categorizedServices = listofServices.reduce((acc, service) => {
        const className = service.class || "Uncategorized"; // Default to 'Uncategorized' if no class
        if (!acc[className]) {
          acc[className] = [];
        }
        acc[className].push(service);
        return acc;
      }, {});

      const categorizedServicesWithAllFirst =
        Object.keys(categorizedServices).length === 1 && categorizedServices['Uncategorized']
          ? { All: sortByPromotional(categorizedServices['Uncategorized']) }
          : {
            All: sortByPromotional(Object.values(categorizedServices).flat()),
            ...Object.fromEntries(
              Object.entries(categorizedServices).map(([key, value]) => [
                key,
                sortByPromotional(value),
              ])
            )
          };
      setCategorizedServices(categorizedServicesWithAllFirst);
    }
  };

  const sortByPromotional = (list) => {
    return list.sort((a, b) => {
      const getPriority = (item) => item.addPromotional === true ? 0 : 1;
      return getPriority(a) - getPriority(b);
    });
  };

  const GetBranchDetails = async (BusinessId, BranchId) => {
    var requestBody = {
      BusinessId: BusinessId,
      BranchId: BranchId,
    };
    let result = await PostAsyncAnonymous(
      "Branch/GetBranchInformation",
      requestBody
    );

    if (!Utils.IsNullOrEmptyArray(result.data)) {
      const branchinfo = result.data.branch;
      const branchLogo = result.data.logoUrl;
      setBranchDetails(branchinfo);
      setBranchLogoURL(branchLogo);

      if (!Utils.IsNullOrEmptyArray(result.data?.makeModel)) {
        const typeMakeModels = result.data.makeModel
        const makeModels = typeMakeModels.filter(t => t.type === branchinfo.vehicleType);
        setMakeList(makeModels.map(c => c.make));
        setMakeModelList(makeModels);
        setIsAutomobileBusiness(branchinfo?.vehicleType != VehicleTypes.None);
      }

      document.title = branchinfo.branchName;
      let branchReservationImageUrl = result.data?.branch?.reservationBranchImageUrl || "";
      if (!Utils.IsNullOrEmpty(branchReservationImageUrl)) {
        setReservationBranchImageUrl(result.data?.branch?.reservationBranchImageUrl)

      }

      setServiceStartTime(branchinfo.startTime);
      setServiceEndTime(branchinfo.endTime);
    }
  };

  const getReservationDetail = async (
    startDate,
    endDate,
    businessId,
    branchId
  ) => {

    var startDT = Utils.GetISODateTimeString(startDate);
    var endDT = Utils.GetISODateTimeString(endDate);

    var Data = {
      BusinessId: businessId,
      BranchId: branchId,
      Start: startDT,
      End: endDT,
      GetReservations: true,
      GetAvailableTimeSlots: true,
      GetProducts: false,
      SelectedLocalDT: startDT,
    };

    var requestBody = {
      BusinessId: businessId,
      BranchId: branchId,
      Data: Data,
    };

    var result = await PostAsyncAnonymous(
      "Branch/GetReservationSlots",
      requestBody
    );
    if (!result.error) {
      const tempreservationsData = result.data;
      setReservationDetails(tempreservationsData);
    }

  };

  const handleOpenOTPModal = async () => {
    if (
      Utils.IsNullOrEmpty(customerMobileNumber) ||
      0 === customerMobileNumber.length ||
      Utils.IsNullOrEmpty(customerName) ||
      0 === customerName.length
    ) {
      setAlertMessage("Please enter mobile number and name");
      setShowAlert(true);
      return;
    }
    if (!Utils.IsMobileValid(customerMobileNumber, CountryHelper.GetCountryObject(branchDetails?.countryCode))) {
      setAlertMessage("Entered mobile number is not valid");
      setShowAlert(true);
      return;
    }
    if (isAddVehicleDetails && Utils.IsNullOrEmpty(customerVehicleNo)) {
      setAlertMessage("Enter vehicle number to add vehicle details");
      setShowAlert(true);
      return;
    }

    setShowMobileNo(false);
    setShowOTP(true);
    setOTP("");
    var id = customerMobileNumber;

    var request = {
      Data: {
        MobileNumber: customerMobileNumber,
        EmailId: "",
        CountryCode: branchDetails.countryCode,
        OTPId: id,
        BusinessId: businessId,
      },
    };
    setLoading(true);
    let result = await PostAsyncAnonymous(
      "Branch/ValidateReservation",
      request
    );
    setLoading(false);
    if (result.error) {
      setAlertMessage(result.errorMessage);
      setShowAlert(true);
      return;
    }
    setOTP("");
    setOTPId(id);
    setShowOTP(true);
  };

  const handleConfirmBookingModal = async () => {
    var request = {
      Data: {
        OTP: otp,
        UserId: otpId,
      },
    };
    setLoading(true);
    let result = await PostAsyncAnonymous(
      "Branch/AuthenticateReservationOTP",
      request
    );
    setLoading(false);
    if (result.error) {
      setShowOTP(false);
      setOTP("");
      setAlertMessage(result.errorMessage);
      setShowAlert(true);
      setCustomerBookingAction(CustomerBookingActions.WrongOTP);
      return;
    }

    if (result.data) {
      setShowOTP(false);
      setCustomerBookingAction(CustomerBookingActions.ProceedReservation);
      reservation();
    }
  };

  const getEncryptedData = async () => {
    var requestBody = {
      Data: {
        PlainText: "B20252#001#Facebook",
      },
    };
    let result = await PostAsyncAnonymous(
      "Branch/GetEncryptedString",
      requestBody
    );
    if (!Utils.IsNullOrEmptyArray(result.data)) {
      const encytemp = result.data;
      console.log("Encrypted Data: ", encytemp);
    }
  };

  const getDecryptedData = async (encryptedData) => {
    var requestBody = {
      Data: {
        EncryptedData: encryptedData,
      },
    };
    let result = await PostAsyncAnonymous(
      "Branch/GetDecryptedString",
      requestBody
    );
    if (!Utils.IsNullOrEmptyArray(result.data)) {
      const decryptedDatatemp = result.data;
      let localSetting = connectToStore();
      setLocalSettings(localSetting);

      const businessId = decryptedDatatemp?.split("#")[0];
      let branchId = decryptedDatatemp?.split("#")[1];
      const socialMediaSource = decryptedDatatemp?.split("#")[2];
      if (branchId === "undefined" && localSetting) {
        branchId = localSetting?.branch?.branchId
      }
      console.log("BusinessId: ", businessId);
      console.log("BranchId: ", branchId);
      console.log("SocialMediaSource: ", socialMediaSource);

      setBusinessId(businessId);
      setBranchId(branchId);
      setSocialMediaSource(socialMediaSource);
      setLoading(true);

      GetAllServices(businessId);
      GetBranchDetails(businessId, branchId);

      getReservationDetail(
        selectedDate[0],
        selectedDate[1],
        businessId,
        branchId
      );

    }
  };

  const reservation = async () => {
    var reservationDT = PublicReservationHelper.getReservationDateTime(
      selectedTimestring,
      selectedDaystring,
      selectedMonthString,
      serviceStartTime
    );
    var serviceItemList = [];
    if (!Utils.IsNullOrEmptyArray(selectedServices)) {
      selectedServices.forEach((serviceId) => {
        var serviceItem = serviceList.find((x) => x.id === serviceId);
        serviceItem.productId = serviceItem.id;
        serviceItem.productCode = serviceItem.code;
        serviceItem.productClass = serviceItem.class;
        serviceItem.productDepartment = serviceItem.department;
        serviceItem.productFineline = serviceItem.fineline;
        serviceItemList.push(serviceItem);
      });
    }
    var reservationRequest = {
      Data: {
        CustomerName: customerName,
        MobileNumber: customerMobileNumber?.trim(),
        BusinessId: businessId,
        BranchId: branchId,
        SocialMediaSource: socialMediaSource,
        CountryCode: branchDetails.countryCode,
        ReservationDT: reservationDT,
        Services: Utils.IsNullOrEmptyArray(serviceItemList)
          ? null
          : serviceItemList,
        CustomerVehicleMake: customerVehicleMake,
        CustomerVehicleModel: customerVehicleModel,
        CustomerVehicleColor: customerVehicleColor,
        CustomerVehicleNumber: customerVehicleNo,
      },
    };
    setLoading(true);
    let result = await PostAsyncAnonymous(
      "Branch/SaveBooking",
      reservationRequest
    );
    setLoading(false);
    if (result.error) {
      setAlertMessage(result.errorMessage);
      setShowAlert(true);
      setCustomerName("");
      setCustomerMobileNumber("");
      setSelectedServices([]);
      setSelectedTime("");
      setSelectedTimeString("");
      setSelectedDaystring("");
      setSelectedMonthString("");
      setOpenModal(false);
      setShowOTP(false);
      setIsConfirmBooking(false);
      setShowTime(false);
      setShowServies(true);
      setCustomerVehicleMake("");
      setCustomerVehicleModel("");
      setCustomerVehicleColor("");
      setCustomerVehicleNo("");
      setIsAddVehicleDetails(false);
      return;
    }
    setIsConfirmBooking(true);
    body.classList.add("bookingConfirmed");
    setCustomerName("");
    setCustomerMobileNumber("");
    setSelectedServices([]);
    setSelectedTime("");
    setSelectedTimeString("");
    setSelectedDaystring("");
    setSelectedMonthString("");
    setShowSuccess(true);
    setShowTime(false);
    setShowServies(true);
    setCustomerVehicleMake("");
    setCustomerVehicleModel("");
    setCustomerVehicleColor("");
    setCustomerVehicleNo("");
    setIsAddVehicleDetails(false);
    setTimeout(
      function () {
        setOpenModal(false);
        setShowOTP(false);
        setIsConfirmBooking(false);
      }.bind(this),
      3000
    );
  };

  const handleShareIcon = async () => {
    const shareData = {
      url: window.location.href,
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        setAlertMessage("Your browser does not support the Web Share API.");
        setShowAlert(true);
      }
    } catch (err) {
      debugger;
      if(err.name === 'AbortError'){
        // User cancelled the share action
        return;
      }
      // setAlertMessage("Error sharing the link." + err.message);
      // setShowAlert(true);
    }
  }

  const vehicleMakeHandleChange = (value) => {
    var make = value;
    var models = [];
    if (!Utils.IsNullOrEmpty(make)) {
      models = makeModelList.find((c) => c.make === make)?.model || [];

    }
    setModelList(models);
  };

  return (
    <Container maxWidth="false" sx={{ paddingBottom: "8rem" }} className="xs-pd-0">
      <Loader open={loading} />
      <Dialog
        open={openModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return; 
          }
          handleCloseModal(); 
        }}
        aria-describedby="alert-dialog-slide-description"
        className="booknow-modal"
      >
        {showOTP && !showMobileNo && (
          <>
            <DialogTitle fontSize="2.4rem" fontWeight="700">
              {"OTP Verification"}
              <Typography fontSize="16px">
                Enter the 6-digit code you received on your mobile
              </Typography>
              <IconButton
                onClick={handleCloseModal}
                title="Close"
                sx={{ position: "absolute", right: "10px", top: "10px" }}
              >
                <CloseOutlinedIcon sx={{ fontSize: "24px" }} />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                <FormControl fullWidth className="otp-field">
                  <NumericTextField
                    name=""
                    placeholder="000000"
                    value={otp}
                    setValue={setOTP}
                    inputProps={{ maxLength: 6 }}
                  />
                </FormControl>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                className="submitBtn cs-btn"
                fullWidth="true"
                onClick={handleConfirmBookingModal}
              >
                Confirm
              </Button>
            </DialogActions>
          </>
        )}

        {showMobileNo && (
          <>
            <DialogTitle fontSize="2rem" fontWeight="700">
              <Typography fontSize="16px">Sign up with your</Typography>
              {"Mobile Number & Name"}
              <IconButton
                onClick={handleCloseModal}
                title="Close"
                sx={{ position: "absolute", right: "10px", top: "10px" }}
              >
                <CloseOutlinedIcon sx={{ fontSize: "24px" }} />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description" className="font-size-16">
                <Stack>
                  <FormControl fullWidth>
                    <Grid container>
                      <Grid xs={4} md={2}>
                        <TextField
                          name=""
                          value={branchDetails.countryCode ?? ""}
                          inputProps={{ maxLength: 12, readOnly: true }}
                          sx={{ "width": "90%" }}
                          disabled
                        />
                      </Grid>
                      <Grid xs={8} md={10}>
                        <TextField
                          name=""
                          id="mobileNumber"
                          label="Mobile Number"
                          variant="outlined"
                          value={customerMobileNumber}
                          error={!customerMobileNumber}
                          onChange={(e) => {
                            const value = e.target.value;
                              if (!/^\d*$/.test(value)) {
                                return;
                              }
                              setCustomerMobileNumber(value);
                          }}
                          inputProps={
                            { 
                              maxLength: CountryHelper.GetMobileNumberMaxLength(),
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                            }}
                          sx={{ "width": "100%" }}
                        />
                      </Grid>
                    </Grid>
                  </FormControl>
                </Stack>
                <Stack mt={2}>
                  <FormControl mt={2} fullWidth>
                    <TextField
                      name=""
                      id="name"
                      label="Name"
                      variant="outlined"
                      value={customerName}
                      error={!customerName}
                      onChange={(e) => setCustomerName(e.target.value)}
                    />
                  </FormControl>
                </Stack>
                {isAutomobileBusiness && <Box>
                  <Stack mt={2} direction="row" justifyContent="space-between" alignItems="center">
                    <Typography fontSize="16px" fontWeight="bold" style={{ color: "black" }}>Add Vehicle Details</Typography>
                    {isAddVehicleDetails ? (
                      <IconButton
                        onClick={() => setIsAddVehicleDetails(false)}
                      >
                        <RemoveCircleIcon
                          fontSize="large"
                          style={{ fill: "#666666", width: "24px", height: "24px" }}
                        />
                      </IconButton>
                    ) : (
                      <IconButton
                        onClick={() => setIsAddVehicleDetails(true)}
                      >
                        <AddCircleIcon
                          fontSize="large"
                          style={{ fill: "#666666", width: "24px", height: "24px" }} />
                      </IconButton>
                    )}
                  </Stack>
                  {isAddVehicleDetails && <Box>
                    <Stack mt={2} direction="row" spacing={2}>
                      <FormControl fullWidth>
                        <TextField
                          id="jobcardVehicleNumber"
                          label="Vehicle Number"
                          variant="outlined"
                          error={!customerVehicleNo}
                          value={customerVehicleNo}
                          onChange={(e) => {
                            setCustomerVehicleNo(Utils.ConvertToUpperCase(e.target.value));
                          }}
                          inputProps={{ maxLength: 16 }}
                        />
                      </FormControl>
                    </Stack>
                    <Stack mt={2} direction="row" spacing={2}>
                      <FormControl fullWidth>
                        <Autocomplete
                          freeSolo
                          options={makeList}
                          value={customerVehicleMake}
                          onChange={(event, newValue) => {
                            setCustomerVehicleMake(newValue || "");
                            vehicleMakeHandleChange(newValue);
                            setCustomerVehicleModel("");
                          }}
                          onInputChange={(event, newInputValue) => {
                            setCustomerVehicleMake(newInputValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Make"
                              variant="outlined"
                            />
                          )}
                          slotProps={{
                            popper: {
                              sx: {
                                '& .MuiAutocomplete-listbox': {
                                  fontSize: '16px',
                                },
                              },
                            },
                          }}
                        />
                      </FormControl>
                      <FormControl fullWidth>
                        <Autocomplete
                          freeSolo
                          options={modelList}
                          value={customerVehicleModel}
                          onChange={(event, newValue) => {
                            setCustomerVehicleModel(newValue || "");
                          }}
                          onInputChange={(event, newInputValue) => {
                            setCustomerVehicleModel(newInputValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Model"
                              variant="outlined"
                            />
                          )}
                          slotProps={{
                            popper: {
                              sx: {
                                '& .MuiAutocomplete-listbox': {
                                  fontSize: '16px',
                                },
                              },
                            },
                          }}
                        />
                      </FormControl>
                    </Stack>
                    <Stack mt={2} direction="row" spacing={2}>
                      <FormControl fullWidth>
                        <TextField
                          id="jobcardColor"
                          label="Color"
                          variant="outlined"
                          value={customerVehicleColor}
                          onChange={(e) => {
                            setCustomerVehicleColor(e.target.value);
                          }}
                        />
                      </FormControl>
                    </Stack>
                  </Box>}
                </Box>}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                className="submitBtn cs-btn"
                fullWidth="true"
                onClick={handleOpenOTPModal}
              >
                Get OTP
              </Button>
            </DialogActions>
          </>
        )}

        {isConfirmBooking && (
          <Box className="confirmed-box" id="confirmBox">
            <DialogTitle>
              <IconButton
                onClick={handleCloseModal}
                title="Close"
                sx={{ position: "absolute", right: "10px", top: "10px" }}
              >
                <CloseOutlinedIcon sx={{ fontSize: "24px" }} />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                className="text-center"
                sx={{ color: "#000000" }}
              >
                <VerifiedIcon
                  sx={{ fontSize: "8rem", color: "rgb(76 175 80)" }}
                />
                <Typography fontSize="20px">Appointment</Typography>
                <Typography component="h3" fontSize="4em" fontWeight="700">
                  confirmed!
                </Typography>
              </DialogContentText>
            </DialogContent>
          </Box>
        )}
      </Dialog>
      {/* Success */}
      <SuccessDialog
        open={showSuccess}
        onClose={closeSuccess}
        message="Your appointment booked successfully"
      />
      {/* Alert */}
      <MessagePopup
        msgOpen={showAlert}
        msgText={alertMessage}
        onMsgClose={closeAlert}
      />

      <Grid container xs={12} className="container-fluid my-1 mx-2 top-sec">
        <Grid xs={6} alignSelf="Center">
          <Stack className="logo-sec" direction="row">
            <Box component="img" src={Infopoint_Logo} />
            <h1>Infopoint</h1>
          </Stack>
        </Grid>
        <Grid xs={6} alignSelf="Center" className="text-right">
          <Button className="btn-primary link-btn" sx={{ height: "auto" }}>
            <a href="https://infopoint.com/" target="_blank" alignSelf="Center">
              Visit Site
            </a>
          </Button>
        </Grid>
      </Grid>

      <Stack className="login-sec">
        <Grid
          className="login-bg container-fluid"
          sx={{
            backgroundImage: !Utils.IsNullOrEmpty(reservationBranchImageUrl) ? `url(${reservationBranchImageUrl})` : undefined,
            backgroundPosition: "center",
            backgroundSize: "cover",
            minHeight: "60vh",
          }}
        >
          <Grid xs={12} className="my-1 mx-2" alignSelf="end">
            <Grid
              xs={12}
              alignSelf="End"
              className="login-title"
            >
              <h1 className="h1 text-white">
                Stay connected with <br /> your business always!
              </h1>
              <p className="mt-3">
                <a
                  href="https://infopoint.com/"
                  target="_blank"
                  className="white-text"
                >
                  Explore more{" "}
                  <Box
                    component="img"
                    sx={{ height: 16, width: 16 }}
                    style={{ cursor: "pointer" }}
                    alt="Contact us"
                    src={up_arrow}
                  />
                </a>
              </p>
            </Grid>
          </Grid>
        </Grid>
      </Stack>

      <Grid container xs={12} className="container profile-details" my={3}>
        <Stack
          direction="row"
          spacing={3}
          justifyContent="space-between"
          width="100%"
        >
          <Stack direction="row" spacing={2}>
            <Avatar className="brand-logo">
              {/* <Box className="brandLogo">H</Box> */}
              <Box
                className="brandLogo"
                sx={{
                  "background-image": `url(${branchLogoURL})`,
                  "background-color": "#000",
                }}
              ></Box>
            </Avatar>
            <Stack alignSelf="center">
              <Typography component="h3" fontSize="3rem" fontWeight="800">
                {branchDetails?.branchName}
              </Typography>
              <Typography fontSize="14px">
                <EventIcon sx={{ fontSize: "18px", position: "relative", top: "2px" }} alignSelf="center" />{" "}
                &nbsp; Open all days from{" "}
                {Utils.GetTime(branchDetails?.startTime)} to{" "}
                {Utils.GetTime(branchDetails?.endTime)}
              </Typography>
              <Typography fontSize="14px">
                <PlaceIcon sx={{ fontSize: "18px", position: "relative", top: "2px" }} alignSelf="center" />{" "}
                &nbsp; {branchDetails?.address}
              </Typography>
            </Stack>
          </Stack>
          <Stack spacing={3} className="share-icon">
            {/* <Link href="#" target="_blank" alignSelf="end"> */}
            <ShareOutlinedIcon onClick={handleShareIcon} sx={{ fontSize: "32px", cursor: "pointer" }} />
            {/* </Link> */}
            {/* <Button
              variant="outlined"
              endIcon={<ExpandMoreOutlinedIcon />}
              sx={{ fontSize: "16px" }}
            >
              Details
            </Button> */}
          </Stack>
        </Stack>

        <Grid container mt={6} className="my-xs-1">
          {showTime && (
            <Grid item xs={12} sm={6} md={6} className="p-xs-0">
              <Stack direction="row" spacing={1}>
                <IconButton
                  sx={{ alignItems: "center", alignSelf: "center" }}
                  title="Go back to select services"
                  onClick={handleShowServices}
                  className="back-btn"
                >
                  <ArrowBackIosIcon sx={{ fontSize: "24px" }} />
                </IconButton>
                <Typography component="p" fontSize="2rem" fontWeight="800">
                  Select Time
                </Typography>
              </Stack>
              <Stack spacing={2} sx={{ width: "100%" }} mt={2} className="m-xs-0">
                <Box className="sticky-header">
                  <Tabs
                    className="cs-tabs"
                    value={timeValue}
                    onChange={handleTimeTabsChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    sx={{
                      [`& .${tabsClasses.scrollButtons}`]: {
                        "&.Mui-disabled": { opacity: 0.3 },
                      },
                    }}
                    aria-label="scrollable auto tabs example"
                  >
                    {reservationDetails?.times?.map((item, itemindex) => (
                      <Tab
                        label={
                          <div className="time-sec">
                            <h6 style={{ textAlign: "center" }}>{item.monthName}</h6>
                            <h4>{item.day}</h4> <span>{item.dayName}</span>
                          </div>
                        }
                        {...a11yProps({ itemindex })}
                      />
                    ))}
                  </Tabs>
                </Box>
                {reservationDetails?.times?.map((item, index) => {
                    const hasAnyAvailableSlot = item?.slots?.some((slotObject, timeIndex) => {
                      const neededSlots = Math.ceil(
                        totalTime / branchDetails?.reservationTimeInterval
                      );

                      const selectedSlots = item.slots.slice(
                        timeIndex,
                        timeIndex + neededSlots
                      );

                      return (
                        selectedSlots.length === neededSlots &&
                        selectedSlots.every((s) => s.isAvailable)
                      );
                    });

                return (
                  <CustomTabPanel
                    key={index}
                    value={timeValue}
                    index={index}
                    className="m-xs-0 service-item-cards"
                  >
                    {hasAnyAvailableSlot ? (
                      item?.slots?.map((slotObject, timeIndex) => {
                        const neededSlots = Math.ceil(
                          totalTime / branchDetails?.reservationTimeInterval
                        );

                        const selectedSlots = item.slots.slice(
                          timeIndex,
                          timeIndex + neededSlots
                        );

                        const isContinuouslyAvailable =
                          selectedSlots.length === neededSlots &&
                          selectedSlots.every((s) => s.isAvailable);

                        return (
                          isContinuouslyAvailable && (
                            <Card className="card" key={timeIndex}>
                              <Stack padding={2} paddingRight="70px" className="p-xs-1">
                                <label>
                                  <Typography
                                    component="h3"
                                    fontSize="2.2rem"
                                    fontWeight="700"
                                  >
                                    {slotObject.time}
                                  </Typography>

                                  <Box className="select-service">
                                    <input
                                      type="radio"
                                      name={item.day}
                                      value={slotObject.time}
                                      checked={
                                        selectedTimestring === slotObject.time &&
                                        selectedDaystring === item.day
                                      }
                                      onChange={(e) => {
                                        setSelectedTimeString(e.target.value);
                                        setSelectedDaystring(item.day);
                                        setSelectedMonthString(item.month);
                                        setSelectedTime(
                                          PublicReservationHelper.formatCustomDate(
                                            e.target.value,
                                            item.day,
                                            item.month,
                                            serviceStartTime
                                          )
                                        );
                                      }}
                                    />
                                  </Box>
                                </label>
                              </Stack>
                            </Card>
                          )
                        );
                      })
                    ) : (
                      <Typography
                        align="center"
                        color="text.secondary"
                        fontSize="1.6rem"
                        padding={2}
                      >
                       No time slots available
                      </Typography>
                    )}
                  </CustomTabPanel>
                );
              })}

              </Stack>
            </Grid>
          )}
          {showServies && (
            <Grid item xs={12} sm={6} md={6} className="service-item-cards">
              <Typography component="p" fontSize="2rem" fontWeight="800">
                Select Services
              </Typography>
              <Box sx={{ width: "100%" }} mt={2} className="service-items">
                <Box className="sticky-header m-xs-0" sx={{ width: "100%", marginBottom: "16px" }}>
                  <Tabs
                    className="cs-tabs"
                    value={serviceValue}
                    onChange={handleServiceTabsChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    sx={{
                      [`& .${tabsClasses.scrollButtons}`]: {
                        "&.Mui-disabled": { opacity: 0.3 },
                      },
                    }}
                    aria-label="scrollable auto tabs example"
                  >
                    {/* {serviceCategory.map((sc, index) => (
                      <Tab key={sc} label={sc} {...a11yProps(index)} />
                    ))} */}

                    {Object.keys(categorizedServices).map((category, index) => (
                      <Tab
                        key={category}
                        label={category}
                        {...a11yProps(index)}
                      />
                    ))}
                  </Tabs>
                </Box>

                {Object.keys(categorizedServices).map((category, index) => (
                  <CustomTabPanel
                    key={category}
                    value={serviceValue}
                    index={index}
                  >
                    {categorizedServices[category].map(
                      (service, serviceIndex) => (
                        <ServiceItem
                          key={serviceIndex}
                          title={service.shortDesc}
                          duration={Utils.ConvertMinutesToTimeString(
                            service.serviceTime + service.postServiceTime
                          )}
                          price={Utils.GetCurrency(service.price, CountryHelper.GetCountryObject(branchDetails?.countryCode))}
                          selected={selectedServices.includes(service.id)}
                          onToggle={() => handleToggle(service.id)}
                          service={service}
                        />
                      )
                    )}
                  </CustomTabPanel>
                ))}
              </Box>
            </Grid>
          )}
          <Grid item xs={12} sm={1} md={1}></Grid>
          <Grid item xs={12} sm={5} md={5} sx={{ position: "sticky", bottom: "0px", zIndex: 9 }}>
            <Card className="card" sx={{ position: "sticky", top: "10px", marginTop: "10px" }}>
              <Stack
                padding={3}
                spacing={1}
                sx={{ borderBottom: 1, borderColor: "divider" }}
                className="hidden-xs"
              >
                <Typography
                  component="h3"
                  fontSize="2.2rem"
                  fontWeight="700"
                  marginBottom="10px"
                >
                  {branchDetails?.branchName}
                </Typography>
                {showTime && (
                  <Typography fontSize="16px" fontWeight="700">
                    <EventIcon sx={{ fontSize: "16px" }} alignSelf="center" />{" "}
                    &nbsp; {selectedTime || "None"}
                  </Typography>
                )}
                <Typography fontSize="16px">
                  <PlaceIcon sx={{ fontSize: "16px" }} alignSelf="center" />{" "}
                  &nbsp; {branchDetails?.address}
                </Typography>
              </Stack>

              <Stack padding={3} spacing={3} className="p-xs-0 m-xs-0">
                {selectedServices?.map((service, index) => (
                  <Stack
                    key={index}
                    justifyContent="space-between"
                    direction="row"
                    mb={2} // optional spacing between items
                    className="hidden-xs"
                  >
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        component="h3"
                        fontSize="2rem"
                        fontWeight="600"
                      >
                        {serviceList.find((x) => x.id === service)?.shortDesc}
                      </Typography>
                      <Typography fontSize="1.4rem">
                        {Utils.ConvertMinutesToTimeString(
                          serviceList.find((x) => x.id === service)
                            ?.serviceTime +
                          serviceList.find((x) => x.id === service)
                            ?.postServiceTime
                        )}
                      </Typography>
                    </Box>
                    <Typography
                      component="h3"
                      fontSize="1.6rem"
                      fontWeight="700"
                    >
                      {Utils.GetCurrency(
                        serviceList.find((x) => x.id === service)?.price, CountryHelper.GetCountryObject(branchDetails?.countryCode)
                      )}
                    </Typography>
                  </Stack>
                ))}

                <Stack
                  justifyContent="space-between"
                  direction="row"
                  sx={{ borderTop: 1, borderColor: "divider" }}
                  paddingTop={2}
                  className="total-sec p-xs-0 m-xs-0"
                >
                  <Typography component="h3" fontSize="2rem" fontWeight="600">
                    Total
                  </Typography>
                  <Typography component="h3" fontSize="2rem" fontWeight="700">
                    {Utils.GetCurrency(
                      selectedServices?.reduce((sum, serviceId) => {
                        const service = serviceList.find(
                          (x) => x.id === serviceId
                        );
                        return sum + (service?.price || 0);
                      }, 0), CountryHelper.GetCountryObject(branchDetails?.countryCode)
                    )}
                  </Typography>
                </Stack>
              </Stack>

              <Stack padding={3} mt={2} className="p-xs-1 m-xs-0">
                {showServies && (
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="large"
                    className="submitBtn cs-btn"
                    fullWidth="true"
                    onClick={handleShowTime}
                  >
                    Continue
                  </Button>
                )}

                {showTime && (
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="large"
                    className="submitBtn cs-btn"
                    fullWidth="true"
                    onClick={handleClickOpenModal}
                  >
                    Book Now
                  </Button>
                )}
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Container >
  );
};

export default BrandHome;
